import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { makeFormField, isValidEmail } from '@/helpers';
import { ErrorMode } from '@/models';
import { Routes } from '@/router';

@Component({
  name: 'CmgPasswordResetRequestForm',
})
export default class CmgPasswordResetRequestForm extends Vue {
  email = makeFormField();
  isRequestingReset = false;
  isRequestSuccessful = false;
  errorMessage = '';
  isFormValid = true;
  vendorSignInRoute = { name: Routes.VendorSignIn };

  get showBackLink(): boolean {
    return this.$router.currentRoute.name === Routes.VendorPasswordResetRequestPage;
  }
  
  validateEmail(): void {
    if (this.email.value.length == 0) {
      this.email.error = 'Email Required';
    } else {
      this.email.error = !isValidEmail(this.email.value) ? 'Please Enter A Valid Email' : '';
    }

    this.email.errorMode = ErrorMode.PlaceHolder;
  }

  validateForm(): void {
    this.isFormValid = true;
    this.validateEmail();

    if (!!this.email.error) {
      this.email.dirty = true;
      this.isFormValid = false;
    }
  }

  async onClickContinue(): Promise<void> {
    this.isRequestingReset = true;
    this.errorMessage = '';

    this.validateForm();

    try {
      if (!this.isFormValid) {
        return;
      }

      await this.$services.customer.resetPasswordRequest({ 'EmailAddress': this.email.value});

      this.isRequestingReset = true;
      this.isRequestSuccessful = true;

    } catch (err) {
      this.$services.logger.info(err);
    } finally {
      this.isRequestingReset = false;
    }

    this.$emit('reset-request-event', this.email.value);
  }

  onClose() {
    this.redirectOrGoToSignIn();
  }

  private redirectOrGoToSignIn() {
    // If there is a return URL, then follow it. Otherwise
    // route to order home.
    const url = this.$router.currentRoute.query.returnUrl;

    if (url) {
      window.location.href = url.toString();
    } else {
      this.$router.push({ name: Routes.SignIn });
    }
  }
}
